import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, ChapterTag } from "./primitives";

const Vision = () => {
  const config = useSiteConfig();
  return (
    <section className="relative py-28 lg:py-44 border-t border-line overflow-hidden" data-testid="vision-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(24,183,160,0.07),transparent_60%)]" aria-hidden="true" />
      <div className="section-shell relative text-center">
        <Reveal className="flex justify-center">
          <ChapterTag index={14} label="Five-Year Vision" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-display font-bold tracking-tight leading-[1.02] text-5xl sm:text-7xl lg:text-8xl text-mist" data-testid="vision-headline">
            Beyond the <span className="text-teal">Token</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 mx-auto max-w-2xl text-base md:text-lg text-slate leading-relaxed" data-testid="vision-copy">
            The long-term vision: JCV as the native utility asset across payments, governance and decentralized
            applications. This is not just a token — it is the beginning of an ecosystem.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-12 flex flex-wrap justify-center gap-3 max-w-4xl mx-auto" data-testid="vision-areas">
            {config.vision.map((v) => (
              <li
                key={v}
                className="rounded-full border border-line bg-deep/70 px-5 py-2.5 font-mono text-[11px] sm:text-xs tracking-[0.15em] uppercase text-slate hover:border-teal/50 hover:text-teal transition-colors duration-300"
              >
                {v}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.35}>
          <p className="mt-10 font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-slate/70">
            Future concepts — not existing products
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Vision;
